import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'extension.coursePartner.pageTitle',
    defaultMessage: 'Start a Campus',
    description: 'Browser title for the Start a Campus page.',
  },
  heroTitle: {
    id: 'extension.coursePartner.heroTitle',
    defaultMessage: 'Start a campus',
    description: 'Main heading in the Start a Campus hero.',
  },
  heroDescription: {
    id: 'extension.coursePartner.heroDescription',
    defaultMessage: 'Bring your teachings online. Gather your community. Reach students everywhere.',
    description: 'Supporting text in the Start a Campus hero.',
  },
  heading: {
    id: 'extension.coursePartner.heading',
    defaultMessage: 'Start your campus on WeBuddhist Academy',
    description: 'Heading above the campus benefits.',
  },
  introduction: {
    id: 'extension.coursePartner.introduction',
    defaultMessage: 'Join a platform for authentic Buddhist education, connecting your teaching with students and institutions around the world.',
    description: 'Introduction to starting a campus.',
  },
  preservationTitle: {
    id: 'extension.coursePartner.preservationTitle',
    defaultMessage: 'Knowledge Preservation',
    description: 'Title of the knowledge preservation benefit.',
  },
  preservationDescription: {
    id: 'extension.coursePartner.preservationDescription',
    defaultMessage: 'Digitise and safeguard your lineage’s teaching so it remains available to students long after the term ends.',
    description: 'Description of the knowledge preservation benefit.',
  },
  reachTitle: {
    id: 'extension.coursePartner.reachTitle',
    defaultMessage: 'Reach a Global Sangha',
    description: 'Title of the global reach benefit.',
  },
  reachDescription: {
    id: 'extension.coursePartner.reachDescription',
    defaultMessage: 'Your courses sit alongside the work of established schools and reach practitioners on every continent.',
    description: 'Description of the global reach benefit.',
  },
  infrastructureTitle: {
    id: 'extension.coursePartner.infrastructureTitle',
    defaultMessage: 'Specialised Infrastructure',
    description: 'Title of the infrastructure benefit.',
  },
  infrastructureDescription: {
    id: 'extension.coursePartner.infrastructureDescription',
    defaultMessage: 'We provide and maintain the video hosting, structured lessons, certificates and student support your courses need.',
    description: 'Description of the infrastructure benefit.',
  },
  contact: {
    id: 'extension.coursePartner.contact',
    defaultMessage: 'Contact us',
    description: 'Heading and call-to-action label for contacting WeBuddhist Academy.',
  },
  fullName: {
    id: 'extension.coursePartner.fullName',
    defaultMessage: 'Full name',
    description: 'Label for the contact name field.',
  },
  workEmail: {
    id: 'extension.coursePartner.workEmail',
    defaultMessage: 'Work email',
    description: 'Label for the contact email field.',
  },
  organizationName: {
    id: 'extension.coursePartner.organizationName',
    defaultMessage: 'Organization name',
    description: 'Label for the organization name field.',
  },
  organizationDescription: {
    id: 'extension.coursePartner.organizationDescription',
    defaultMessage: 'A short description of your organization',
    description: 'Label for the organization description field.',
  },
  submit: {
    id: 'extension.coursePartner.submit',
    defaultMessage: 'Submit',
    description: 'Contact form submit button label.',
  },
  submitting: {
    id: 'extension.coursePartner.submitting',
    defaultMessage: 'Sending…',
    description: 'Contact form submit button label while sending.',
  },
  formError: {
    id: 'extension.coursePartner.formError',
    defaultMessage: 'Sorry, there was a problem submitting your request. Please try again later.',
    description: 'Fallback error shown when the contact form cannot be submitted.',
  },
  campusesTitle: {
    id: 'extension.startCampus.campusesTitle',
    defaultMessage: 'Campuses',
    description: 'Title above the campus logo carousel.',
  },
  previousCampuses: {
    id: 'extension.startCampus.previousCampuses',
    defaultMessage: 'Previous campuses',
    description: 'Accessible label for the previous carousel button.',
  },
  nextCampuses: {
    id: 'extension.startCampus.nextCampuses',
    defaultMessage: 'Next campuses',
    description: 'Accessible label for the next carousel button.',
  },
  ctaTitle: {
    id: 'extension.coursePartner.ctaTitle',
    defaultMessage: 'Let’s continue this <em>conversation</em>',
    description: 'Heading in the final contact call to action.',
  },
  ctaDescription: {
    id: 'extension.coursePartner.ctaDescription',
    defaultMessage: 'Together we can bring high-impact education to every audience — let’s build the future of dharma preservation.',
    description: 'Supporting text in the final contact call to action.',
  },
});

export default messages;
